<div class="login-loading">
  <div class="spinner"></div>
  <p>Loading...</p>
</div>
